import { useEffect, useState } from 'react';

/** 在组件挂载时等待异步模块就绪 */
export function useDeferredModule(loader: () => Promise<void>): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void loader().then(() => {
      if (!cancelled) {
        setReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [loader]);

  return ready;
}
